/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopCanvasItem'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopCanvasItem'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopCanvasItemApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopCanvasItem);
  }
}(this, function(ApiClient, WorkshopCanvasItem) {
  'use strict';

  /**
   * WorkshopCanvasItem service.
   * @module api/WorkshopCanvasItemApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopCanvasItemApi. 
   * @alias module:api/WorkshopCanvasItemApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopCanvasItemAddPut operation.
     * @callback module:api/WorkshopCanvasItemApi~workshopCanvasItemAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopCanvasItem} body 
     * @param {module:api/WorkshopCanvasItemApi~workshopCanvasItemAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workshopCanvasItemAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopCanvasItemAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopCanvasItemAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/WorkshopCanvasItem/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopCanvasItemDeleteGet operation.
     * @callback module:api/WorkshopCanvasItemApi~workshopCanvasItemDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopCanvasItemApi~workshopCanvasItemDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopCanvasItemDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopCanvasItemDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopCanvasItemDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopCanvasItem/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopCanvasItemEditPut operation.
     * @callback module:api/WorkshopCanvasItemApi~workshopCanvasItemEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopCanvasItem} body 
     * @param {module:api/WorkshopCanvasItemApi~workshopCanvasItemEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopCanvasItemEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopCanvasItemEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopCanvasItemEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopCanvasItem/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopCanvasItemLoadGet operation.
     * @callback module:api/WorkshopCanvasItemApi~workshopCanvasItemLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopCanvasItem} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopCanvasItemApi~workshopCanvasItemLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopCanvasItem}
     */
    this.workshopCanvasItemLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopCanvasItemLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopCanvasItemLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopCanvasItem;

      return this.apiClient.callApi(
        '/WorkshopCanvasItem/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
